import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-85387c3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "px-2"
};
const _hoisted_2 = {
    key: 1,
    class: "px-2"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", { class: "far fa-folder text-yellow-600" }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = ["title"];
const _hoisted_6 = {
    key: 0,
    class: "block text-xs text-left truncate text-gray-600"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-down" }, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = {
    key: 3,
    class: "flex justify-end items-center flex-grow px-1"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-right opacity-40" }, null, -1));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = {
    key: 4,
    class: "flex justify-end items-center flex-grow px-1"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["p-1 border-gray-200 border-folder md:items-center hover:bg-gray-200 hover:border-button", {
                'border-button border-t border-l border-r': _ctx.showHover,
                'border-blue-300 border-folder border-t border-l border-r': _ctx.isActive && _ctx.isFolderActive,
                'z-overlay': _ctx.showMenu,
            }]),
        onDrop: _cache[4] || (_cache[4] =
            //@ts-ignore
            (...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
        onDragover: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.showHover = true), ["prevent"])),
        onDragleave: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.showHover = false), ["prevent"])),
        onDragenter: _cache[7] || (_cache[7] = _withModifiers(() => { }, ["prevent"]))
    }, [
        _createElementVNode("div", {
            class: "flex flex-grow items-center md:flex-row overflow-hidden",
            onClick: _cache[3] || (_cache[3] = () => _ctx.onClick(_ctx.folder))
        }, [
            (_ctx.folder.metaData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("em", {
                        class: _normalizeClass(["far", `fas fa-${(_a = _ctx.folder.metaData) === null || _a === void 0 ? void 0 : _a.icon}`]),
                        style: _normalizeStyle(`color: ${(_b = _ctx.folder.metaData) === null || _b === void 0 ? void 0 : _b.color}`)
                    }, null, 6)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
            _createElementVNode("div", {
                class: _normalizeClass({ 'flex flex-col truncate': _ctx.showMenuOptions })
            }, [
                _createElementVNode("span", {
                    title: _ctx.translate(`folder.${_ctx.folder.name}`, _ctx.folder.name),
                    class: "block text-primary font-semibold truncate text-xs"
                }, _toDisplayString(_ctx.translate(`folder.${_ctx.folder.name}`, _ctx.folder.name)), 9, _hoisted_5),
                (_ctx.showFileCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('file.fileListing', _ctx.folder.fileAmount, {
                        count: _ctx.folder.fileAmount ? _ctx.folder.fileAmount : 0,
                    })), 1))
                    : _createCommentVNode("", true)
            ], 2),
            (_ctx.showMenu)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.openMenu && _ctx.openMenu(...args)), ["stop"])),
                    class: "md:hidden flex justify-end items-center flex-grow px-1"
                }, _hoisted_8))
                : _createCommentVNode("", true),
            (_ctx.showClickIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true),
            (_ctx.showMenuOptions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.edit }))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.editCategory && _ctx.editCategory(...args)), ["stop"]))
                        }, [
                            _createElementVNode("em", {
                                title: `${_ctx.$t('misc.actions.edit')}`,
                                class: "text-blue-400 opacity-50 cursor-pointer fas fa-edit fa-sm mr-2"
                            }, null, 8, _hoisted_13)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.delete }))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.removeCategory && _ctx.removeCategory(...args)), ["stop"]))
                        }, [
                            _createElementVNode("em", {
                                title: `${_ctx.$t('misc.actions.delete')}`,
                                class: "text-red-400 opacity-50 cursor-pointer fas fa-trash fa-sm"
                            }, null, 8, _hoisted_14)
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true)
        ])
    ], 34));
}
